import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mealFilterFlight',
  pure: false // Mark as impure to allow re-running the filter when selectedMealTypes changes
})
export class MealFilterFlightPipe implements PipeTransform {

  transform(mealItems: any[], selectedMealTypes: Set<string>): any[] {
    // If no data or selectedMealTypes is empty, return all items (no filtering)
    if (!mealItems || mealItems.length === 0 || selectedMealTypes.size === 0) {
      return mealItems;
    }
  
    // Filter based on selectedMealTypes (0 for veg, 1 for non-veg)
    return mealItems.filter(item => {
      if (selectedMealTypes.has('0') && item.is_veg === true) {
        return true; // Veg meal
      }
      if (selectedMealTypes.has('1') && item.is_veg === false) {
        return true; // Non-veg meal
      }
      if (selectedMealTypes.has('2') && item.is_veg === null || item.is_veg === '') {
        return true; // Non-veg meal
      }
      return false; // Skip item if no match
    });
  }

}
